import { UnitType } from '@exodus/currency'

const name = 'bitcoinsv'
const displayName = 'Bitcoin SV'
const ticker = 'BSV'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#EDAC00'
const gradientColors = ['#EDAC00', '#E6A700']
const gradientCoords = { x1: '4.602%', y1: '4.602%', x2: '0%', y2: '100%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  BSV: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => {
    return `https://blockchair.com/bitcoin-sv/address/${address}`
  },
  txUrl: (txId) => `https://blockchair.com/bitcoin-sv/transaction/${txId}`,
}
const info = {
  description:
    'Bitcoin SV (Satoshi Vision) is a fork of Bitcoin Cash. The stated purpose of Bitcoin SV is to preserve Bitcoin’s original design.',
  reddit: 'https://www.reddit.com/r/bitcoinsv/',
  twitter: 'https://twitter.com/BitcoinSVNode',
  website: 'https://bitcoinsv.io/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
